import { QueryClient } from '@tanstack/react-query';
import { AccessNotProvisionedError, ApiError, isRetryableApiError } from '@/api/errors';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 5xx and network failures retry with backoff. Auth failures never do:
        // a 401 or 403 is not a transient condition, and retrying one is how a
        // sign-out storm or a redirect loop starts.
        retry: (failureCount, error) => {
          if (error instanceof AccessNotProvisionedError) return false;
          if (error instanceof ApiError && !isRetryableApiError(error)) return false;
          return failureCount < 3;
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
